<template>
  <div class="pv">
    <div class="pv__head">
      <div class="pv__total">{{ total }}</div>
      <div class="pv__total-label">款商品已铺货</div>
    </div>
    <div class="pv__grid">
      <div v-for="(pl, i) in plats" :key="pl.n" class="pv__cell">
        <div class="pv__cell-head">
          <span class="pv__cell-name" :style="{ color: pl.c }">{{ pl.n }}</span>
          <span class="pv__cell-val" :style="{ color: pl.c }">{{ pcts[i] }}%</span>
        </div>
        <div class="pv__bar">
          <div class="pv__bar-fill" :style="{ width: pcts[i] + '%', background: `linear-gradient(90deg, ${pl.c}, #D4A946)` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevDistrib',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      pcts: [0, 0, 0, 0, 0, 0, 0],
      total: 0,
      timer: null,
      plats: [
        { n: '抖店', c: '#00F0FF' }, { n: '微店', c: '#FF6B35' }, { n: '淘宝', c: '#FF6B35' },
        { n: '京东', c: '#E8321A' }, { n: '快手', c: '#FF3B30' }, { n: '拼多多', c: '#E44D4D' },
        { n: '小红书', c: '#FF2C55' }
      ]
    }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.pcts = [0, 0, 0, 0, 0, 0, 0]; this.total = 0; return }
      this.timer = setInterval(() => {
        this.pcts = this.pcts.map(p => Math.min(p + 3, 100))
        this.total = Math.min(this.total + 6, 1200)
      }, 60)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__head { text-align: center; margin-bottom: 10px; }
.pv__total { font-family: Inter, monospace; font-size: 28px; font-weight: 700; color: #D4A946; line-height: 1; }
.pv__total-label { font-size: 11px; color: rgba(220, 215, 240, .6); }
.pv__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.pv__cell {
  border-radius: 8px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .1);
}
.pv__cell-head { display: flex; justify-content: space-between; margin-bottom: 4px; }
.pv__cell-name { font-size: 11px; }
.pv__cell-val { font-family: Inter; font-size: 10px; }
.pv__bar { height: 4px; border-radius: 2px; background: rgba(255, 255, 255, .08); overflow: hidden; }
.pv__bar-fill { height: 100%; border-radius: 2px; transition: width .06s; }
</style>
